import script from "./ProgramOverviewSetup.vue?vue&type=script&setup=true&lang=js"
export * from "./ProgramOverviewSetup.vue?vue&type=script&setup=true&lang=js"

import "./ProgramOverviewSetup.vue?vue&type=style&index=0&id=5b05c2f1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b05c2f1"]])

export default __exports__